import { Link } from "react-router-dom"

const CustomerLink = ({ customer, fallbackName, className = "" }) => {
  const identifier = customer?.cuid || customer?.id
  const name = customer?.name || fallbackName || "-"

  if (!identifier) {
    return <span className={className}>{name}</span>
  }

  return (
    <Link
      to={`/customer-list/${identifier}/view`}
      className={`text-decoration-none text-primary ${className}`.trim()}
    >
      {name}
    </Link>
  )
}

export default CustomerLink